/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * The current status of the cancellation (requested, accepted, rejected, etc.)
 * @export
 * @enum {string}
 */
export const CancellationStatus = {
    Requested: 'requested',
    Accepted: 'accepted',
    Rejected: 'rejected',
    PartialRequested: 'partialRequested',
    PartialAccepted: 'partialAccepted',
    PartialRejected: 'partialRejected'
};
